<template>
  <el-form class="chart-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="dashboardId">
      <template slot="label">
        <span class="require-flag">*</span>
        关联看板
      </template>
      <normal-select
        :select-list="boardList"
        :selected-item.sync="control.dashboardId"
        @handle-select="clearChartId"
      ></normal-select>
    </el-form-item>
    <el-form-item prop="chartId">
      <template slot="label">
        <span class="require-flag">*</span>
        关联图表
      </template>
      <normal-select
        :select-list="chartList"
        :selected-item.sync="control.chartId"
        @handle-select="clearCondition"
      ></normal-select>
    </el-form-item>
    <el-form-item prop="chartId">
      <template slot="label">
        条件
      </template>
      <el-button type="text" @click="chartFilterVisible = true">设置筛选条件</el-button>
    </el-form-item>
    <el-form-item prop="height">
      <template slot="label">
        高度
      </template>
      <div class="height">
        <el-input-number
          v-model="control.height"
          :min="0"
          :controls="false"
          class="number"
        ></el-input-number>
        <span class="unit">px</span>
      </div>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <sheet-filter
      @submit="setCondition"
      :dialog-visible.sync="chartFilterVisible"
      :search-sheet="chartSheet"
      :rely-sheet-info="sheet"
      :condition-list="control['filters']"
      from="sheet_backend"
    ></sheet-filter>
  </el-form>
</template>

<script>
import { getManageDashboardList } from "@/api/appManage/statistics"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import SheetFilter from "@/components/UIComponents/SheetFilter"

export default {
  name: "chart-control",
  components: { SheetFilter, NormalSelect },
  props: {
    control: Object,
    sheet: Object,
    availableSheets: Array
  },
  data() {
    return {
      boards: [],
      chartFilterVisible: false
    }
  },
  computed: {
    boardList() {
      return this.boards.map(board => ({ label: board.name, value: board.id }))
    },
    charts() {
      let board = this.boards.find(board => board.id === this.control.dashboardId)
      return board?.charts || []
    },
    chartList() {
      return this.charts?.map(chart => ({ label: chart.name, value: chart.chartId })) || []
    },
    chart() {
      return this.charts.find(chart => chart.chartId === this.control.chartId) || {}
    },
    chartSheet() {
      if (!this.chart.sheetId) return {}
      for (let app of this.availableSheets) {
        let sheet = app.sheets.find(i => i.sheetId === this.chart.sheetId)
        if (sheet) return sheet
      }
      return {}
    }
  },
  created() {
    getManageDashboardList(this.sheet.appId).then(res => (this.boards = res))
  },
  methods: {
    setCondition(condition) {
      this.control.filters = condition
    },
    clearChartId() {
      this.control.chartId = null
    },
    clearCondition() {
      this.control.filters = []
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-control {
  .height {
    display: flex;
    align-items: center;
    position: relative;
    .number {
      width: 100%;
    }
    .unit {
      position: absolute;
      right: 8px;
    }
  }
  ::v-deep {
    .el-input-number .el-input__inner {
      text-align: left;
    }
  }
}
</style>
